export default __webpack_public_path__ + "static/media/WoL_web_checker_banner_image_logo2@640-min.0c99cb88.jpg";